import { cn } from '../../lib/cn';

type Props = {
  regions?: string[];
  active?: string;
  onChange?: (region: string) => void;
};

export function ProductWorkspaceNav({
  regions = [],
  active,
  onChange,
}: Props) {
  return (
    <nav className="flex flex-wrap gap-1" aria-label="Product workspace regions">
      {regions.map((r) => (
        <button
          key={r}
          type="button"
          onClick={() => onChange?.(r)}
          className={cn(
            'rounded-lg px-3 py-1.5 text-xs font-medium transition',
            active === r
              ? 'bg-brand-600 text-white'
              : 'border border-slate-200 text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-800',
          )}
        >
          {r}
        </button>
      ))}
    </nav>
  );
}
